export default function RequiredMark() {
  return <span className="text-red-500"> *</span>;
}
